import { required } from "common/validate";
import { composeValidators } from "utils/validations";

export const formValidators = {
  price: composeValidators(required, (value) => {
    if (value <= 0) return "Invalid price";
  }),
};
